import moment, {Moment} from 'jalali-moment';
import {useEffect, useState} from 'react';

const useRecorderChat = () => {
  const [generatedBlob, setGeneratedBlob] = useState<Blob | undefined>(
    undefined,
  );

  const [isRecording, setisRecording] = useState(false);
  const [audioChunks, setAudioChunks] = useState<Array<Blob>>([]);
  const [timer, setTimer] = useState<number>();
  const [now, setNow] = useState<Moment>();
  const nowTime = moment();

  const start = () => {
    setNow(moment());
  };

  const end = () => {
    const duration = moment.duration(moment().diff(now));
    setTimer(duration.asMilliseconds());
  };

  useEffect(() => {
    let interval: NodeJS.Timer | undefined;
    if (isRecording) {
      start();
      interval = setInterval(() => {
        const duration = moment.duration(moment().diff(nowTime));
        setTimer(duration.asMilliseconds());
      }, 1000);
    } else {
      clearInterval(interval);
      end();
    }

    return () => clearInterval(interval);
  }, [isRecording]);

  return {
    generatedBlob,
    isRecording,
    audioChunks,
    timer,
    setGeneratedBlob,
    setisRecording,
    setAudioChunks,
    setTimer,
  };
};

export default useRecorderChat;
